module.exports = __webpack_public_path__ + "img/tp.1abb9f2b.png";